(function () {
  'use strict';

  angular
    .module('web2print.landing')
    .directive('additionalServiceSelector', additionalServiceSelector);

  /* @ngInject */
  function additionalServiceSelector () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/landing/additional-service-selector/additional-service-selector.directive.html',
      scope: {
        additionalServices: '=',
        isCustomerCompany: '=',
        selectedType: '='
      },
      link: linkFunc,
      controller: AdditionalServiceSelectorController,
      controllerAs: 'additionalServiceSelector',
      bindToController: true
    };

    return directive;

    function linkFunc (scope, el, attr, ctrl) {
      el.addClass('additional-service-selector');

      scope.$watch('additionalServiceSelector.additionalServices', scope.additionalServiceSelector.activate);

    }
  }

  AdditionalServiceSelectorController.$inject = ['Common'];

  /* @ngInject */
  function AdditionalServiceSelectorController (Common) {
    const vm = this;

    vm.activate = activate;
    vm.calculateMorphTotalPrice = Common.calculateMorphTotalPrice;
    vm.setSelectedServiceInGroup = setSelectedServiceInGroup;
    vm.getSelectedServiceInGroup = getSelectedServiceInGroup;
    vm.toggleService = toggleService;
    vm.checkAdditionalServices = checkAdditionalServices;

    //////////////////////////

    function activate (newVal, oldVal) {
      if (newVal && (newVal !== oldVal || !vm.groupedServices)) {
        vm.groupedServices = _.chain(vm.additionalServices)
          .filter(notDeliveryOption)
          .groupBy(groupByTypeNameIfExisting)
          .map(formatGroup)
          .value();
      }
    }

    function notDeliveryOption (service) {
      return service.type !== 'deliveryOption';
    }

    function groupByTypeNameIfExisting (service, index) {
      const groupName = _.get(service, 'type.name');
      return groupName || index;
    }

    function formatGroup (group) {
      const res = {
        services: group
      };

      if (group[0].type && group[0].type.group) {
        res.selectedService = _.find(group, {selected: true}) || group[0];
      }

      return res;
    }

    function setSelectedServiceInGroup (group, selectedService) {
      _.each(group.services, function (service, index) {
        const additionalService = _.find(vm.additionalServices, {type: service.type});
        service.selected = service.type === selectedService.type;
        additionalService.selected = service.selected;
      });
    }

    function getSelectedServiceInGroup (group) {
      const selectedService = _.find(group, {selected: true});
      return selectedService ? selectedService : group[0];
    }

    function toggleService (service) {
      const additionalService = _.findWhere(vm.additionalServices, {additionalServiceId: service.additionalServiceId});
      additionalService.selected = service.selected;
    }

    function checkAdditionalServices (service) {
      if (service.included) {
        delete service.override;
      }

      if (typeof service.type !== 'undefined') {
        if (service.selected) {


          _.each(vm.additionalServices, function (_service) {
            if (_service.type === service.type) {

              if (_service.additionalServiceId !== service.additionalServiceId) {
                _service.selected = false;

                if (_service.included) {
                  _service.override = true;
                }
              } else {
                _service.selected = true;
              }
            }
          });
          return service;
        } else {
          _.each(vm.additionalServices, function (_service) {
            if (_service.included) {
              _service.override = false;
            }

            if (_service.additionalServiceId === service.additionalServiceId) {
              _service.selected = false;
            }
          });
        }
      } else {
        const additionalService = _.findWhere(vm.additionalServices,
          {additionalServiceId: service.additionalServiceId});
        additionalService.selected = service.selected;
      }
    }
  }
})();
